// extracted by mini-css-extract-plugin
export default {"main_button":"MainButton_main_button__wwfiH","disabled":"MainButton_disabled__n76Tx"};